module.exports = __webpack_public_path__ + "media/application/images/2018/2018-rating-lock-a6af39a71e944f9bbd07d945dd6dab5b.svg";